// based on rc-notification 3.3.1
import Notification from './Notification';
export default Notification;
